import { ResponseSeoInfo } from '@/src/interfaces/data-contracts';
import { getHost } from '@/src/utils/helpers/get-host';
import JsonLd from '@/src/utils/helpers/jsonld';

const WebPageSchema = ({ seoInfo, canonicalPath = '' }: { seoInfo?: ResponseSeoInfo; canonicalPath?: string }) => {
  let host = getHost();

  if (host && !host.includes('www')) {
    host = host.replace('https://', 'https://www.');
  }

  // const canonicalUrl = canonicalPath ? `${host}${canonicalPath}` : '';

  const schema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    // '@id': canonicalUrl,
    description: seoInfo?.metaDescription,
    name: seoInfo?.title,
    publisher: { '@type': 'Organization', name: 'hangikredikobi.com' },
  };

  return <JsonLd type="WebPage" scriptKey="webPage" schema={schema} />;
};

export default WebPageSchema;
